<template>
  <div class="grid" :class="containerCss">
    <slot />
  </div>
</template>

<script>
import UIkitComponentWrapper from '@/mixins/UIkitComponentWrapper';

export default {
  name: 'grid',
  mixins: [
    UIkitComponentWrapper({ name: 'grid' }),
  ],
  props: {
    size: String,
    divider: Boolean,
    matchHeight: Boolean,
  },
  computed: {
    containerCss() {
      return {
        [`uk-grid-${this.size}`]: !!this.size,
        'uk-grid-divider': this.divider,
        'uk-grid-match': this.matchHeight,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// Grid.vue?077e6fa6